import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Open/closed state of the Solicitantes LISTING modal.
 *
 * A registry has no route of its own: clicking Cadastros → Solicitantes opens the modal over
 * whatever page the user is on, and closing it leaves them exactly where they were. Mirrors
 * `HealthFacilitiesModalService`.
 *
 * The host renders the modal only while `open$` is true, so a fresh layout always mounts closed —
 * navigating with the overlay open never leaves a stale copy behind.
 */
@Injectable({ providedIn: 'root' })
export class SolicitantesModalService {
  private readonly openState$ = new BehaviorSubject<boolean>(false);

  /** Emits the current state; replays the latest value to new subscribers. */
  readonly open$: Observable<boolean> = this.openState$.asObservable();

  get isOpen(): boolean {
    return this.openState$.value;
  }

  open(): void {
    this.openState$.next(true);
  }

  close(): void {
    this.openState$.next(false);
  }
}
